import { render } from "./SovFooter.vue?vue&type=template&id=03ee53f6&scoped=true"
import script from "./SovFooter.vue?vue&type=script&lang=js"
export * from "./SovFooter.vue?vue&type=script&lang=js"

import "./SovFooter.vue?vue&type=style&index=0&id=03ee53f6&scoped=true&lang=css"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ee53f6"]])

export default __exports__